import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Maintenance from '../pages/maintenance';
import { useEffect, useState } from 'react';
import { HealthyControllerService } from '../services';
import apiErrorHandler from '../api/apiErrorHandler';

const MaintenanceRoute = () => {
    const dispatch = useDispatch();
    const storage = useSelector((state) => state.storage);
    const { maintenance } = storage;
    const [viewPage, setViewPage] = useState(null);

    useEffect(() => {
        isShow();
    }, [maintenance]);

    const isShow = async () => {
        if (maintenance) {
            setViewPage(<Maintenance />);
            return;
        }
        try {
            await HealthyControllerService.healthy();
            setViewPage(<Outlet />);
        } catch (error) {
            apiErrorHandler(dispatch, error);
        }
    };

    return viewPage;
};

export default MaintenanceRoute;
